import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface CustomBillingAddressTooltipProps {
  openLeft: boolean
}

const CustomBillingAddressTooltip: React.FC<
  CustomBillingAddressTooltipProps
> = (props): React.ReactElement => {
  return (
    <Tooltip openLeft={props.openLeft}>
      <p>
        <Trns
          source={
            '${virtualCardBillingAddress} is the same as the underlying account\'s billing address. To change it for this virtual card only, select "Change Billing Address" and enter a custom address. This can only be done when creating a virtual card.'
          }
          expressions={{
            virtualCardBillingAddress: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                <Trns source={'Virtual card billing address'} />
              </span>
            ),
          }}
        />
      </p>
    </Tooltip>
  )
}

export default CustomBillingAddressTooltip
